import { isNull } from 'lodash';
import React from 'react';
import './NoBank.scss';
import { ADD_BANK_MODAL } from '../../../redux/modules/modals/modals.module';
import Button from '../../Shared/Button/Button';

const NoBank = ({
  isSalesforceRep,
  customerWebViewEnabled,
  error,
  actions: { openModal },
}) => {
  return (
    <div>
      <div className="e2e-no-bank-container no-bank-add-a-bank-account-a">
        Add a bank account as your funding source.
      </div>
      <div className="no-bank-add-a-bank-account-b">
        It's quick, easy, and secure.
      </div>
      {!(!customerWebViewEnabled && isSalesforceRep) && (
        <span>
          <div className="no-bank-add-a-bank-button">
            {isNull(error) ? (
              <Button
                buttonType="primary"
                onClick={() => openModal(ADD_BANK_MODAL)}
                type="button"
                disabled={false}
              >
                Add New Bank
              </Button>
            ) : (
              <div className="no-bank-add-a-bank-error">
                Error: We’re unable to process your request.  Please{' '}
                <a
                  className="exclude"
                  href="https://www.troweprice.com/personal-investing/help/contact/index.html"
                  rel="noreferrer"
                  target="_blank"
                >
                  Contact US
                </a>
                .
              </div>
            )}
          </div>
        </span>
      )}
    </div>
  );
};

export default NoBank;
